const DEFAULT_MENU = [
  { name: 'geo', title: 'Территориальная схема', number: '01',
    childs: [
      {name: 'geo.objects'},
      {name: 'geo.treads'},
      {name: 'geo.forecasts'},
      {name: 'geo.apos'}
    ]
  },
  { name: 'atu'},
  { name: 'target'},
  { name: 'garbage',
    childs: [
      {
        name: 'garbage.organizations'
      },
      {
        name: 'garbage.defenses'
      },
      {
        name: 'garbage.medics'
      },
      {
        name: 'garbage.managers'
      },
      {
        name: 'garbage.individualAreas'
      },
      {
        name: 'garbage.countryCommunitys'
      },
      {
        name: 'garbage.garages'
      },
      {
        name: 'garbage.settlements'
      },
      {
        name: 'garbage.apartmentBuildings'
      }
    ]
  },
  { name: 'msn',
    childs: [
      {
        name: 'msn.withContainers'
      },
      {
        name: 'msn.withoutContainers'
      },
      {
        name: 'msn.separateCollections'
      }
    ]
  },
  { name: 'unauthorized',
    childs: [
      {
        name: 'unauthorized.heaps'
      },
      {
        name: 'unauthorized.wpf'
      }
    ]
  },
  { name: 'garbageObjectRegistry', title: 'Реестр объектов по обращению с отходами', number: '07'},
  { name: 'registry', title: 'Реестры', number: '08',
    childs: [
      {
        name: 'registry.operators'
      },
      {
        name: 'registry.contracts'
      }
    ]
  },
  { name: 'analytic', title: 'Аналитика', number: '09'},
  { name: 'classifier', title: 'Кадастр отходов', number: '10',
    childs: [
      {name: 'classifier.fkko'},
      {name: 'classifier.groro'},
      {name: 'classifier.tech'},
      {name: 'classifier.garbage'}
    ]
  },
  { name: 'regionalOperators', title: 'Региональные операторы', number: '11'},
  {
    name: 'access',
    number: '12',
    childs: [
      { name: 'access.users'},
      { name: 'access.usersGroups'},
      {name: 'access.journals'},
      {name: 'access.tariffs'},
      {name: 'access.population'},
      {name: 'access.formed'},
      {name: 'access.publicFile'}
    ]
  },
  {
    number: '13',
    name: 'waybill'},
  {
    name: 'routes',
    number: '14',
    childs: [
      {name: 'routes.routes'},
      {name: 'routes.schedule'}
    ]
  },
  {
    name: 'carPark',
    number: '15',
  },
  {
    name: 'staffManagement',
    number: '16'
  },
];

export default DEFAULT_MENU
